import { default as IndexDViMv2jZ4dMeta } from "@/src/pages-modules/home/Index.vue?macro=true";
import { default as MaterialMineve4zHWmyYUMeta } from "@/src/pages-modules/material-manage/MaterialMine.vue?macro=true";
import { default as MaterialListAa1mVeYpOUMeta } from "@/src/pages-modules/material-manage/MaterialList.vue?macro=true";
import { default as ChapterListvYHV0jBJg2Meta } from "@/src/pages-modules/chapter-manage/ChapterList.vue?macro=true";
import { default as ChapterYearsZzgwKp7C4XMeta } from "@/src/pages-modules/chapter-manage/ChapterYears.vue?macro=true";
import { default as ChapterImitateJfr7eJvT7iMeta } from "@/src/pages-modules/chapter-manage/ChapterImitate.vue?macro=true";
import { default as IndexEvJq0sd4vUMeta } from "@/src/pages-modules/exam/exam-detail/Index.vue?macro=true";
import { default as IndexnNEUPltpwyMeta } from "@/src/pages-modules/exam/exam-answer/Index.vue?macro=true";
import { default as IndexDjfvpSIrGgMeta } from "@/src/pages-modules/exam/exam-result/Index.vue?macro=true";
import { default as IndexmaprhbetZQMeta } from "@/src/pages-modules/exam/exam-analyze/Index.vue?macro=true";
export default [
  {
    name: IndexDViMv2jZ4dMeta?.name ?? "home",
    path: IndexDViMv2jZ4dMeta?.path ?? "/",
    meta: IndexDViMv2jZ4dMeta || {},
    alias: IndexDViMv2jZ4dMeta?.alias || [],
    redirect: IndexDViMv2jZ4dMeta?.redirect,
    component: () => import("@/src/pages-modules/home/Index.vue").then(m => m.default || m)
  },
  {
    name: MaterialMineve4zHWmyYUMeta?.name ?? "material-mine",
    path: MaterialMineve4zHWmyYUMeta?.path ?? "/material-manage/mine",
    meta: MaterialMineve4zHWmyYUMeta || {},
    alias: MaterialMineve4zHWmyYUMeta?.alias || [],
    redirect: MaterialMineve4zHWmyYUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialMine.vue").then(m => m.default || m)
  },
  {
    name: MaterialListAa1mVeYpOUMeta?.name ?? "material-list-root",
    path: MaterialListAa1mVeYpOUMeta?.path ?? "/material-manage/list/sub-:subjectId(\\d+)?",
    meta: MaterialListAa1mVeYpOUMeta || {},
    alias: MaterialListAa1mVeYpOUMeta?.alias || [],
    redirect: MaterialListAa1mVeYpOUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialList.vue").then(m => m.default || m)
  },
  {
    name: MaterialListAa1mVeYpOUMeta?.name ?? "material-list",
    path: MaterialListAa1mVeYpOUMeta?.path ?? "/material-manage/list",
    meta: MaterialListAa1mVeYpOUMeta || {},
    alias: MaterialListAa1mVeYpOUMeta?.alias || [],
    redirect: MaterialListAa1mVeYpOUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialList.vue").then(m => m.default || m)
  },
  {
    name: ChapterListvYHV0jBJg2Meta?.name ?? "chapter-list-root",
    path: ChapterListvYHV0jBJg2Meta?.path ?? "/chapter-manage/list/sub-:subjectId(\\d+)?",
    meta: ChapterListvYHV0jBJg2Meta || {},
    alias: ChapterListvYHV0jBJg2Meta?.alias || [],
    redirect: ChapterListvYHV0jBJg2Meta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterList.vue").then(m => m.default || m)
  },
  {
    name: ChapterListvYHV0jBJg2Meta?.name ?? "chapter-list",
    path: ChapterListvYHV0jBJg2Meta?.path ?? "/chapter-manage/list",
    meta: ChapterListvYHV0jBJg2Meta || {},
    alias: ChapterListvYHV0jBJg2Meta?.alias || [],
    redirect: ChapterListvYHV0jBJg2Meta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterList.vue").then(m => m.default || m)
  },
  {
    name: ChapterYearsZzgwKp7C4XMeta?.name ?? "chapter-years-root",
    path: ChapterYearsZzgwKp7C4XMeta?.path ?? "/chapter-manage/years/sub-:subjectId(\\d+)?",
    meta: ChapterYearsZzgwKp7C4XMeta || {},
    alias: ChapterYearsZzgwKp7C4XMeta?.alias || [],
    redirect: ChapterYearsZzgwKp7C4XMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterYears.vue").then(m => m.default || m)
  },
  {
    name: ChapterYearsZzgwKp7C4XMeta?.name ?? "chapter-years",
    path: ChapterYearsZzgwKp7C4XMeta?.path ?? "/chapter-manage/years",
    meta: ChapterYearsZzgwKp7C4XMeta || {},
    alias: ChapterYearsZzgwKp7C4XMeta?.alias || [],
    redirect: ChapterYearsZzgwKp7C4XMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterYears.vue").then(m => m.default || m)
  },
  {
    name: ChapterImitateJfr7eJvT7iMeta?.name ?? "chapter-imitate-root",
    path: ChapterImitateJfr7eJvT7iMeta?.path ?? "/chapter-manage/imitate/sub-:subjectId(\\d+)?",
    meta: ChapterImitateJfr7eJvT7iMeta || {},
    alias: ChapterImitateJfr7eJvT7iMeta?.alias || [],
    redirect: ChapterImitateJfr7eJvT7iMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterImitate.vue").then(m => m.default || m)
  },
  {
    name: ChapterImitateJfr7eJvT7iMeta?.name ?? "chapter-imitate",
    path: ChapterImitateJfr7eJvT7iMeta?.path ?? "/chapter-manage/imitate",
    meta: ChapterImitateJfr7eJvT7iMeta || {},
    alias: ChapterImitateJfr7eJvT7iMeta?.alias || [],
    redirect: ChapterImitateJfr7eJvT7iMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/ChapterImitate.vue").then(m => m.default || m)
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "normal-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/normal-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":3} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "imitate-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/imitate-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":4} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "previous-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/previous-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":5} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexnNEUPltpwyMeta?.name ?? "exam-answer",
    path: IndexnNEUPltpwyMeta?.path ?? "/exam/answer/em-:examMode(\\d+)/:id(\\d+)?",
    meta: { ...(IndexnNEUPltpwyMeta || {}), ...{"hideFooter":true,"showTheme":true} },
    alias: IndexnNEUPltpwyMeta?.alias || [],
    redirect: IndexnNEUPltpwyMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-answer/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexDjfvpSIrGgMeta?.name ?? "exam-result",
    path: IndexDjfvpSIrGgMeta?.path ?? "/exam/result/em-:examMode(\\d+)/:id(\\d+)?",
    meta: IndexDjfvpSIrGgMeta || {},
    alias: IndexDjfvpSIrGgMeta?.alias || [],
    redirect: IndexDjfvpSIrGgMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-result/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexmaprhbetZQMeta?.name ?? "exam-analyze",
    path: IndexmaprhbetZQMeta?.path ?? "/exam/analyze/em-:examMode(\\d+)/:id(\\d+)?",
    meta: { ...(IndexmaprhbetZQMeta || {}), ...{"hideFooter":true} },
    alias: IndexmaprhbetZQMeta?.alias || [],
    redirect: IndexmaprhbetZQMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-analyze/Index.vue").then(m => m.default || m)
  }
]